import {
  BankDataTypes,
  BranchNameType,
  GetProvinceByBankParamTypes,
  ProvinceByBankItemTypes
} from './types';

import axiosInstance from 'services/common/instance';

export const getAllBankService = async (
  params?: BaseFilterParams & {
    _name?: string;
    _provinceCode?: string
  },
): Promise<APIPaginationResponse<BankDataTypes[]>> => {
  const res = await axiosInstance.get('banks', { params });
  return res.data;
};

export const getBranchService = async (params?: BaseFilterParams)
  : Promise<APIPagination<BranchNameType[]>> => {
  const res = await axiosInstance.get('banks/banks', {
    params
  });
  return res.data;
};

export const getProvinceByBankNameService = async (
  params?: GetProvinceByBankParamTypes
): Promise<APIPaginationResponse<ProvinceByBankItemTypes[]>> => {
  const res = await axiosInstance.get('banks/provinces', { params });
  return res.data;
};
